export const Project1 = `<div class=" common-details">
<div class="d-flex justify-content-between">
<div class="common-name"></div>
<div class="common-date"></div>
 </div>
<div class="common-location"></div>
</div>`;
